import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  // Define paths where scrolling to top should be ignored
  // You can add paths to this array if you want to ignore scrolling for specific routes
  const pathsToIgnore = [];

  useEffect(() => {
    // Scroll to top of the page on route change
    // console.debug("ScrollToTop useEffect", pathname);
    if (!pathsToIgnore.includes(pathname)) {
        window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null; // This component doesn't render anything
}
